import http from '@/http'
import { state as commonState, mutations as commonMutations, SET_LOADING, RESET_LOADING } from '@/store/modules/common'

export const state = {
  selectedPickup: null,
  selectedDelivery: null,
  // pickupNeighborhoodList: [],
  // deliveryNeighborhoodList: [],
  // selectedNeighborhoodPickup: null,
  // selectedNeighborhoodDelivery: null,
  ...commonState
}

export const mutations = {
  SET_PICKUP(state, selectedPickup) {
    state.selectedPickup = selectedPickup;
  },
  SET_DELIVERY(state, selectedDelivery) {
    state.selectedDelivery = selectedDelivery;
  },
  // SET_PICKUP_NEIGHBORHOOD_LIST(state, pickupNeighborhoodList) {
  //   state.pickupNeighborhoodList = pickupNeighborhoodList;
  // },
  // SET_DELIVERY_NEIGHBORHOOD_LIST(state, deliveryNeighborhoodList) {
  //   state.deliveryNeighborhoodList = deliveryNeighborhoodList;
  // },
  // SET_NEIGHBORHOOD_PICKUP(state, selectedNeighborhoodPickup) {
  //   state.selectedNeighborhoodPickup = selectedNeighborhoodPickup;
  // },
  // SET_NEIGHBORHOOD_DELIVERY(state, selectedNeighborhoodDelivery) {
  //   state.selectedNeighborhoodDelivery = selectedNeighborhoodDelivery;
  // },
  ...commonMutations
}

export const actions = {
  getVehicleAvailability({ commit }, obj) {
    commit(SET_LOADING);
    return http.get(`/api/vehicle/availability/`, { params: { hash: obj.hash, vehicle_id: obj.vehicle_id } })
      .then(response => {
        commit(RESET_LOADING)

        if ([200, 201].includes(response.status)) {
          if (response.data.result.error) {
            return Promise.reject(response.data.result.error)
          }
          return Promise.resolve(response.data)
        }
      })
      .catch(error => {
        commit(RESET_LOADING)
        return Promise.reject(error)
      })
  },
  getVehicleDetails({ commit }, obj) {
    commit(SET_LOADING);
    return http.get(`/api/vehicle/car_details/`, { params: { hash: obj.hash, vehicle_id: obj.vehicle_id } })
      .then(response => {
        commit(RESET_LOADING)

        if ([200, 201].includes(response.status)) {
          if (response.data.result.error) {
            return Promise.reject(response.data.result.error)
          }
          return Promise.resolve(response.data)
        }
      })
      .catch(error => {
        commit(RESET_LOADING)
        return Promise.reject(error)
      })
  },
  postVehicleBooking({ commit, rootState }, data) {
    commit(SET_LOADING);

    return http.post(`/api/vehicle/booking/`, data)
      .then(response => {
        commit(RESET_LOADING)

        if ([200, 201].includes(response.status)) {
          if (response.data.results.error) {
            return Promise.reject(response.data.results.error)
          }
          return Promise.resolve(response.data.results)
        } else {
          return Promise.reject(response.data)
        }
      })
      .catch(error => {
        commit(RESET_LOADING)
        return Promise.reject(error.response.data.message)
      })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
